// Imports => Constants
import { KEYS } from '@opp/ui-kit';

// Imports => Utilities
import { AcLockObject } from '@opp/ui-kit';
import { AcRequestTransformer } from '@utils';

(function () {
  if (typeof window.CustomEvent === 'function') return false; //If not IE

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

export default AcLockObject({
  locale: 'en-GB',
  apiUrl: process.env.API_URL,
  appName: process.env.APP_NAME,
  environment: process.env.APP_ENV || null,
  pkce: {
    client_id: process.env.CLIENT_ID || null,
    accounts_uri: process.env.ACCOUNTS_URI || null,
    redirect_uri: process.env.REDIRECT_URI || null,
    authorization_endpoint: process.env.AUTHORIZATION_ENDPOINT || null,
    token_endpoint: process.env.TOKEN_ENDPOINT || null,
  },
  maxFileSize: 104857600,
  noSessionEvent: new CustomEvent(KEYS.NO_SESSION),
  autologout: {
    active: process.env.APP_AUTO_LOGOUT || true,
    time: process.env.APP_AUTO_LOGOUT_TIME || 15,
  },
  api: {
    baseURL: process.env.API_URL,
    timeout: 1000 * 30,
    maxContentLength: 10000,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-OPP': 'MyOPP',
    },
    transformRequest: [AcRequestTransformer],
    isJsonMime: (mime: string) => {
      const jsonMime: RegExp = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
      return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    }

  },
  api_no_auth: {
    baseURL: process.env.API_URL,
    timeout: 1000 * 30,
    maxContentLength: 10000,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-OPP': 'MyOPP',
    },
  },
  api_no_base: {
    baseURL: '',
    timeout: 1000 * 30,
    responseEncoding: 'utf8',
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-OPP': 'MyOPP',
    },
    transformRequest: [AcRequestTransformer],
  },
  api_plain: {
    baseURL: process.env.API_URL,
    timeout: 1000 * 30,
    maxContentLength: 10000,
    responseEncoding: 'utf8',
    withCredentials: true,
    headers: { 'X-OPP': 'MyOPP' },
    transformRequest: [AcRequestTransformer],
  },
  api_download: {
    baseURL: process.env.API_URL,
    timeout: 1000 * 30,
    responseType: 'blob',
    responseEncoding: 'utf8',
    withCredentials: true,
    headers: { 'X-OPP': 'MyOPP' },
    transformRequest: [AcRequestTransformer],
  },
  api_upload: {
    baseURL: process.env.API_URL,
    timeout: 1000 * 30,
    maxContentLength: 10000,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: true,
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
      type: 'formData',
      'X-OPP': 'MyOPP',
    },
    transformRequest: [
      (data, headers) => AcRequestTransformer(data, headers, false),
    ],
  },
});
